(() => {
  const sections = document.querySelectorAll('[data-dartsrx-ingredients]');

  sections.forEach((section) => {
    const root = section.closest('.dartsrx-ingredients') || section;
    const tabs = section.querySelectorAll('[data-dartsrx-tab]');
    const panels = section.querySelectorAll('[data-dartsrx-panel]');
    const modal = root.querySelector('[data-dartsrx-nutrition-modal]');
    const modalDialog = root.querySelector('.dartsrx-ingredients__modal-dialog');
    const openModalButton = section.querySelector('[data-dartsrx-nutrition-open]');
    const closeModalButtons = root.querySelectorAll('[data-dartsrx-nutrition-close]');
    const originalModalParent = modal?.parentElement;
    const originalModalNextSibling = modal?.nextSibling;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.dartsrxTab;

        tabs.forEach((button) => {
          const isActive = button === tab;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.dartsrxPanel === target);
        });
      });
    });

    section.querySelectorAll('.dartsrx-ingredients__item-button').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.dartsrx-ingredients__item');
        if (!item) return;

        const isOpen = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(isOpen));
      });
    });

    const closeModal = () => {
      if (!modal || modal.hidden) return;
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('dartsrx-modal-open');
      document.body.classList.remove('dartsrx-modal-open');
      if (originalModalParent && modal.parentElement !== originalModalParent) {
        originalModalParent.insertBefore(modal, originalModalNextSibling);
      }
      openModalButton?.focus();
    };

    const openModal = () => {
      if (!modal) return;
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.hidden = false;
      modal.classList.add('is-open');
      document.documentElement.classList.add('dartsrx-modal-open');
      document.body.classList.add('dartsrx-modal-open');
      modalDialog?.focus();
    };

    openModalButton?.addEventListener('click', openModal);
    closeModalButtons.forEach((button) => button.addEventListener('click', closeModal));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });
  });
})();
